<template>
	<div>
		<el-dialog title="新建关联达人" :visible.sync="dialogVisible" width="520px" :before-close="handleClose" :append-to-body="true">
			<el-alert title="达人信息的更新可能会延迟，请耐心等待" type="warning" show-icon :closable="false" />
			<el-form class="mt-16" :model="form" :rules="rules" ref="ruleForm" label-width="82px">
				<div class="label">团长信息</div>
				<el-form-item label="平台">
					<div class="flex flex-align-center">
						<div class="i-douyin"></div>
						<span class="yx-color-text-primary ml-4">抖音</span>
					</div>
				</el-form-item>
				<el-form-item label="关联团长">
					<div>{{ institutionName }}</div>
				</el-form-item>
				<div class="label">基本信息</div>
				<el-form-item label="抖音号" prop="anchor_account">
					<el-input v-model="form.anchor_account" placeholder="请输入抖音号" maxlength="16" />
					<p class="fz-14 yx-color-text-primary">最多16个字，只允许包含字母、数字、下划线和点</p>
				</el-form-item>
				<el-form-item label="达人昵称" prop="anchor_name">
					<el-input v-model="form.anchor_name" placeholder="请输入达人昵称" />
				</el-form-item>
				<el-form-item label="主页链接">
					<el-input v-model="form.main_url" placeholder="请输入达人主页链接" />
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="form.remark" placeholder="请输入" />
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { checkDouYin } from '@/utils/validate';
import { addinstitutionAnchor } from '@/api/secondColonelManage';

export default {
	name: 'addTalentDialog',
	data() {
		return {
			dialogVisible: false,
			institutionName: '',
			form: {
				team_institution_id: '',
				anchor_account: '',
				anchor_name: '',
				main_url: '',
				remark: '',
			},
			rules: {
				anchor_account: [
					{ required: true, message: '请输入抖音号', trigger: 'blur' },
					{ required: true, validator: checkDouYin, trigger: 'blur' },
				],
				anchor_name: { required: true, message: '请输入达人昵称', trigger: 'blur' },
			},
		};
	},
	methods: {
		show(team_institution_id, institutionName) {
			this.institutionName = institutionName;
			this.form.team_institution_id = team_institution_id;
			this.dialogVisible = true;
		},
		handleClose() {
			this.institutionName = '';
			this.form = {
				team_institution_id: '',
				anchor_account: '',
				anchor_name: '',
				main_url: '',
				remark: '',
			};
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		submit: throttle(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { form } = this;
				const { code } = await addinstitutionAnchor(form);
				if (code !== 0) return;
				this.$message.success('添加成功');
				this.$emit('getList');
				this.handleClose();
			});
		}, 1000),
	},
};
</script>

<style lang="less" scoped>
.label {
	font-size: 16px;
	color: #1d1f23;
	line-height: 20px;
	height: 20px;
	border-left: 4px solid @color-primary;
	padding-left: 8px;
	margin-bottom: 16px;
}
.add-partner {
	line-height: 13px;
	font-size: 13px;
	color: #333;
	.add {
		cursor: pointer;
		color: @color-primary;
	}
}
</style>
